import { render } from "./ManageDevices.vue?vue&type=template&id=0bd33f10&ts=true"
import script from "./ManageDevices.vue?vue&type=script&lang=ts"
export * from "./ManageDevices.vue?vue&type=script&lang=ts"

import "./ManageDevices.vue?vue&type=style&index=0&id=0bd33f10&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__